import { CONTENT_MAX_WIDTHS } from '@sleepstation/metrics-public-site'
import React from 'react'
import BreakoutModule from '../BreakoutModule'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BreakoutModuleWide = (props) => (
  <BreakoutModule {...props} maxWidths={CONTENT_MAX_WIDTHS} />
)

export default BreakoutModuleWide
